import { useSyncExternalStore } from 'react';

/**
 * FASE 121 (121.B.2) — estado GLOBAL do "peek" do master: um dock lateral (desktop) que mostra o espelho/
 * chat do MASTER ORCHESTRATOR SOBRE o deck, sem navegar (sem ocupar a tela inteira, sem trocar de rota).
 * Store minimo (modulo-level + useSyncExternalStore), acessivel de qualquer componente (MasterControl no
 * header abre; o MasterPeek renderiza). Desktop-only por design (o consumidor guarda com useIsMobile).
 */
let open = false;
const listeners = new Set<() => void>();

function emit(): void {
  for (const l of listeners) l();
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

export function openMasterPeek(): void {
  if (!open) {
    open = true;
    emit();
  }
}

export function closeMasterPeek(): void {
  if (open) {
    open = false;
    emit();
  }
}

export function useMasterPeekOpen(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => open,
    () => false,
  );
}
